import React from "react";
import { Helmet } from "react-helmet";
import Navigation from "../../components/Navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
// import { InlineWidget } from "react-calendly";
import "./Reservation.css";

export default function Reservation() {
  return (
    <div
      className="Reservation"
      alt="Sixth & Main Event Center is a venue reservable for several types of events included baby showers, bridal showers, birthdays, and more!"
    >
      <Helmet>
        <title>
          Reserve Now - Book Your Event at Sixth & Main Event Center
        </title>

        {/* SEO description */}
        <meta
          name="description"
          content="Reserve your date now at Sixth & Main Event Center. Our all-inclusive rental packages include venue space, décor, tables, chairs, linens, and essential supplies for a seamless event. Book now!"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Reserve Now - Book Your Event at Sixth & Main Event Center"
        />
        <meta
          property="og:description"
          content="Reserve your date now at Sixth & Main Event Center. Our all-inclusive rental packages include venue space, décor, tables, chairs, linens, and essential supplies for a seamless event. Book now!"
        />
        <meta
          property="og:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />
        <meta
          property="og:url"
          content="https://sixthandmaineventcenter.com/reservation"
        />
        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content="Reserve Now - Book Your Event at Sixth & Main Event Center"
        />
        <meta
          name="twitter:description"
          content="Ready to host your event at Sixth & Main Event Center? Reserve your date and secure our premier venue rental space for an unforgettable occasion. Book now."
        />
        <meta
          name="twitter:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://sixthandmaineventcenter.com/reservation"
        />

        {/* JSON-LD structured data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": "Service",
                  "@id": "https://sixthandmaineventcenter.com/reservation#service",
                  "name": "Event Venue Rental Service",
                  "description": "All-inclusive event venue rental packages including rental space, décor, tables, chairs, linens, and essential supplies.",
                  "provider": {
                    "@type": "Organization",
                    "name": "Sixth & Main Event Center",
                    "url": "https://sixthandmaineventcenter.com"
                  },
                  "areaServed": {
                    "@type": "Place",
                    "address": {
                      "@type": "PostalAddress",
                      "streetAddress": "101 N 6th St Unit A",
                      "addressLocality": "Robstown",
                      "addressRegion": "TX",
                      "postalCode": "78380",
                      "addressCountry": "US"
                    }
                  }
                },
                {
                  "@type": "ScheduleAction",
                  "name": "Book Your Event Venue Reservation",
                  "description": "Schedule your event venue reservation online using our booking scheduler.",
                  "object": {
                    "@id": "https://sixthandmaineventcenter.com/reservation#service"
                  },
                  "target": {
                    "@type": "EntryPoint",
                    "urlTemplate": "https://calendly.com/sixthandmain/venue-reservation",
                    "inLanguage": "en-US",
                    "actionPlatform": [
                      "http://schema.org/DesktopWebPlatform",
                      "http://schema.org/MobileWebPlatform"
                    ]
                  },
                  "agent": {
                    "@type": "Organization",
                    "name": "Sixth & Main Event Center"
                  },
                  "participant": {
                    "@type": "Person"
                  }
                }
              ]
            }
          `}
        </script>
      </Helmet>
      <div className="hero">
        <Navigation />
        <div>
          <h1 className="text-white px-4 px-sm-5 mx-lg-5">
            Reserve your venue rental now
          </h1>
        </div>
      </div>

      <div
        name="reservation"
        className="Reservation"
      >
        <p className="text-center mt-5 container">
          Thank you for your interest in hosting your event at Sixth & Main
          Event Center!{" "}
        </p>
        <p className="text-center container">
          Please review the following{" "}
          <span className="fw-medium">Guidelines & Regulations</span> and select
          a venue rental ackage to complete your reservation.
        </p>

        <div>
          <div className="row ms-lg-5 mx-auto">
            <div
              className="col-sm-6 py-3 py-lg-5 my-3 bg-light mx-auto"
              id="regulations"
            >
              <h3 className="text-info-emphasis mb-3">
                Guidelines & Regulations*
              </h3>
              <h6 className="fw-semibold">VENUE RESERVATION (6hrs)</h6>
              <p>
                Reservation includes 1 hr for setup, 4 hrs for the event, and 1
                hr for teardown. Events surpassing the allotted time slot are
                subject to additional fees.{" "}
              </p>
              <h6 className="fw-semibold mt-4 mb-0">PACKAGE PRICING</h6>

              <table className="table table-light text-center mx-auto">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="text-start text-uppercase"
                      style={{ fontSize: "12px", color: "#055160" }}
                    >
                      What's Included
                    </th>
                    <th scope="col">
                      <span
                        className="text-uppercase"
                        style={{ fontSize: "8px" }}
                      >
                        Standard
                      </span>

                      <span
                        className="d-block"
                        style={{ fontSize: "14px", color: "#055160" }}
                      >
                        $500
                      </span>
                    </th>
                    <th scope="col">
                      <span
                        className="text-uppercase"
                        style={{ fontSize: "8px" }}
                      >
                        Premium
                      </span>
                      <span
                        className="d-block"
                        style={{ fontSize: "14px", color: "#055160" }}
                      >
                        $875
                      </span>
                    </th>
                    <th scope="col">
                      <span
                        className="text-uppercase"
                        style={{ fontSize: "8px" }}
                      >
                        Deluxe
                      </span>
                      <span
                        className="d-block"
                        style={{ fontSize: "14px", color: "#055160" }}
                      >
                        $1275
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody id="pricing-table">
                  <tr>
                    <th
                      scope="row"
                      id="table-row-header"
                    >
                      6 hour Venue Rental, Seating for 75 people & Entry
                      Gift/Dessert Table
                    </th>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      id="table-row-header"
                    >
                      Decorative services including Table Covers, Runners, and
                      Centerpieces
                    </th>
                    <td></td>
                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      id="table-row-header"
                    >
                      Photo Backdrop (Balloon, Curtain, or Floral)
                    </th>
                    <td></td>
                    <td></td>
                    <td>✓</td>
                  </tr>
                </tbody>
              </table>

              <p>
                <span
                  className="fw-semibold"
                  style={{ color: "#055160" }}
                >
                  <FontAwesomeIcon
                    icon={icon({
                      name: "calendar-days",
                      family: "duotone",
                      style: "solid",
                    })}
                    className="me-2"
                  />
                  Weekday Special - $400:
                </span>{" "}
                weekday venue rental for 4 hours, seating for 75, and table
                covers. Includes 1 hr for setup, 2 hrs for the event, and 1 hr
                for teardown.
              </p>
              <h6 className="fw-semibold mt-4">PAYMENT TERMS</h6>
              <p>
                <ul>
                  <li>
                    <b>Events Booked Over 45 Days in Advance: </b>50%
                    non-refundable deposit is required to secure the date.
                    Remaining balance is due 45 days prior to the event.
                  </li>
                  <li>
                    <b>Events Booked 14-45 Days in Advance:</b> Full payment is
                    required at the time of booking and is non-refundable.
                  </li>
                </ul>
              </p>

              <p>
                <b>Refundable Cleaning Deposit:</b> A $75 refundable cleaning
                deposit is required for all bookings.
              </p>

              <p>
                Accepted payment methods include credit card, debit card, ACH,
                Apple Pay, and Google Pay. Failure to pay balances when due may
                result in cancellation without refund.
              </p>

              <h6 className="fw-semibold mt-4">BOOKING</h6>
              <p>
                A reservation is not confirmed until payment is received and
                written confirmation is issued by Provider.
              </p>
              <h6 className="fw-semibold mt-4">CAPACITY</h6>
              <p className="pb-sm-3"> Max occupancy of 75 people.</p>
              <p
                className="pb-sm-5"
                style={{ fontSize: "12px" }}
              >
                *Complete terms of service may be reviewed on the package
                booking page.
              </p>
            </div>
            <div className="col-sm-6 mt-0 mt-sm-3 mx-auto calendly-inline-widget">
              <h2 className="fs-1 d-block text-center pt-3 pb-0 mt-5 mt-sm-0 mb-0">
                <FontAwesomeIcon
                  icon={icon({
                    name: "calendar-days",
                    family: "duotone",
                    style: "solid",
                  })}
                  className="me-2"
                />
                Book Now
              </h2>
              <p className="text-center mt-3">
                To begin the booking process, please select from a{" "}
                <b>Venue Rental Package</b> below:
              </p>
              <div
                className="px-lg-5 mx-auto"
                id="cart-buttons"
              >
                <a
                  href="https://sixth-and-main-event-center.checkcherry.com/reservation/set_event?event_type_id=176566"
                  className="btn mt-2 d-block mx-auto py-lg-3 text-uppercase"
                  role="button"
                >
                  <FontAwesomeIcon
                    icon={icon({
                      name: "cart-circle-plus",
                      family: "duotone",
                      style: "solid",
                    })}
                    className="me-2"
                  />
                  Standard Package - $500
                </a>
                <a
                  href="https://sixth-and-main-event-center.checkcherry.com/reservation/set_event?event_type_id=176567"
                  className="btn mt-2 d-block mx-auto py-lg-3 text-uppercase"
                  role="button"
                >
                  <FontAwesomeIcon
                    icon={icon({
                      name: "cart-circle-plus",
                      family: "duotone",
                      style: "solid",
                    })}
                    className="me-2"
                  />
                  Premium Package - $875
                </a>
                <a
                  href="https://sixth-and-main-event-center.checkcherry.com/reservation/set_event?event_type_id=176565"
                  className="btn mt-2 d-block mx-auto py-lg-3 text-uppercase"
                  role="button"
                >
                  <FontAwesomeIcon
                    icon={icon({
                      name: "cart-circle-plus",
                      family: "duotone",
                      style: "solid",
                    })}
                    className="me-2"
                  />
                  Deluxe Package - $1,275
                </a>
                <a
                  href="https://sixth-and-main-event-center.checkcherry.com/reservation/set_event?event_type_id=176877"
                  className="btn mt-2 mb-5 d-block mx-auto py-lg-3 text-uppercase"
                  role="button"
                >
                  <FontAwesomeIcon
                    icon={icon({
                      name: "cart-circle-plus",
                      family: "duotone",
                      style: "solid",
                    })}
                    className="me-2"
                  />
                  Weekday Special - $400
                </a>
              </div>
              {/* Calendly Inline Widget */}
              {/* <InlineWidget
                url="https://calendly.com/sixthandmain/venue-reservation?&hide_gdpr_banner=1"
                pageSettings={{
                  primaryColor: "000",
                  hideEventTypeDetails: true,
                }}
                styles={{ height: "700px" }}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
